export const trimObjectStrings = (data) => {
  const trimmedData = { ...data };

  Object.keys(trimmedData).forEach((key) => {
    if (typeof trimmedData[key] === 'string') {
      trimmedData[key] = trimmedData[key].trim();
    }
  });

  return trimmedData;
};
